export default __webpack_public_path__ + "static/media/keto_alcohol@3x.ed5aaab5.jpg";